import React, { useState } from 'react';
import './VirtualAccountModal.scss';
import { Button, Modal, Accordion } from 'react-bootstrap';
import { connect } from 'react-redux';
import { } from '../../helpers/Session';
import * as actionCreator from '../../actions/';
import CheckedIcon from 'react-ionicons/lib/CheckmarkCircle';
import { LogInOutline } from 'react-ionicons';
import Overlay from '../Overlay/Overlay';
import { useNavigate } from 'react-router';
import languageManager from '../../helpers/Language';
import CacheMemory from '../../helpers/CacheMemory.js';
import { DOMAIN_NAME } from '../../config/default.js';
import { 
    DOMAIN_NAME as DOMAIN_FIDUCIAL,
    PORTAL_URL as FIDUCIAL_PORTAL_URL,
    APP_EXPLORE_ICON_URL as FIDUCIAL_LOGO,
    APP_EXPLORE_ICON_CONF as FIDUCIAL_LOGO_CONF,
    BRAND_NAME as FIDUCIAL_BRAND
} from '../../config/fiducial.js';
import {
    DOMAIN_NAME as DOMAIN_FEDERATED,
    PORTAL_URL as FEDERATED_PORTAL_URL,
    APP_EXPLORE_ICON_URL as FEDERATED_LOGO,
    APP_EXPLORE_ICON_CONF as FEDERATED_LOGO_CONF,
    BRAND_NAME as FEDERATED_BRAND 
} from '../../config/federated.js';
import { 
    DOMAIN_NAME as DOMAIN_JADE,
    PORTAL_URL as JADE_PORTAL_URL,
    APP_EXPLORE_ICON_URL as JADE_LOGO,
    APP_EXPLORE_ICON_CONF as JADE_LOGO_CONF,
    BRAND_NAME as JADE_BRAND
} from '../../config/jade.js';
import UserAnalytic from '../../helpers/UserAnalytic';

const ICON_DFLT_PROPS = {
    width: '48px',
    height: '48px',
    color: 'inherit',
    className: 'checkMarkIcon'
};

const CompanyInformation = ({
    account, currentEntityId,
    onClick
}) => {
    const isActive = (account.entityId === currentEntityId);
    return (
        <div
            className={'d-flex p-3 ci-item ' + (isActive ? 'elm-active' : '')}
            onClick={onClick}
        >
            <div className="flex-shrink-0">
                <CheckedIcon {...ICON_DFLT_PROPS} />
            </div>
            <div className="flex-grow-1 ms-3">
                {account.customerCode}<br/>
                {account.name}
            </div>
        </div>
    );
};

const OtherPortalAccounts = ({
    accounts,
    portalLogo,
    portalUrl,
    portalBrand,
    eventKey,
    sessionSerialized
}) => {
    return (
        <Accordion.Item className="p-1" eventKey={eventKey}>
            <Accordion.Header className="d-flex">
                    <div className="d-flex flex-grow-1 justify-content-start align-items-center">
                        <div className="m-2">
                            <img height="58px" src={portalLogo} alt="portal logo" />
                        </div>
                        <div className="ps-3">
                            <div className="d-block fw-bold">{portalBrand}</div>
                            <div className="d-block text-muted fw-light">{accounts.length} {accounts.length > 1 ? "contacts" : 'contract'}</div>
                        </div>
                    </div>
                    <div className="pe-5">
                    </div>
            </Accordion.Header>
            <Accordion.Body>
                {accounts.map((account, index) => {
                    return (
                        <a 
                            key={account.entityId}
                            href={`${portalUrl}/_/catch/redirection?entityIdTarget=${account.entityId}&session=${sessionSerialized}`}
                            rel="noopener noreferrer"
                            target="_blank" 
                            className="text-decoration-none"
                            style={{color: 'inherit'}}
                        >
                            <div className="company-information d-flex p-3 m-1 other-account-row">
                                <div className="flex-grow-1 ps-1">
                                    {account.customerCode} - <strong>{account.name}</strong>
                                </div>
                                <LogInOutline className="pe-1"/>
                            </div>
                        </a>
                    )
                })}
            </Accordion.Body>
        </Accordion.Item>
    );
};

const VirtualAccountModal = ({
    profile,
    session,
    setProfile,
    setShowVirtualAccount,
    setVirtualAccount
}) => {
    const navigateManager = useNavigate();
    const vAccounts = profile._vAccounts;
    //const currentEntityId = currentVirtualAccount ? currentVirtualAccount : userProfile.entityId;
    const currentEntityId = session?.currentVirtualAccount;
    const otherVAccounts = profile._othersVAccounts;
    const hasOtherPortalAccounts = Object.values(otherVAccounts).reduce((memo, current) => memo + current.length, 0);
    const [isVisible, setIsVisible] = useState(true);
    const [hasChanged, setHasChanged] = useState(false);
    const [isLoading, setLoadingState] = useState(false);
    const handleSetVirtualAccount = async (virtualAccountId) => {
        setLoadingState(true);
        UserAnalytic.event({
            category: 'Virtual Account',
            action: 'Change V Account',
        });
        setVirtualAccount(virtualAccountId);
        setHasChanged(true);
        setIsVisible(false);
    };
    const handleExit = () => {
        setLoadingState(false);
        setShowVirtualAccount(false);
        if (hasChanged) {
            navigateManager('/');
        }
    };
    const sessionSerialized = CacheMemory.serialize(session.expires_in, {...session, expires_in: null});

    return (
        <>
        <Overlay show={isLoading} />
        <Modal
            show={isVisible}
            size="lg"
            className="vaccount-modal-content"
            onExited={handleExit}
        >
            <Modal.Body>
                <h1 className="text-center mb-4 mt-2">
                    {languageManager.T('SWCH_ACC_MDL_LABEL_TITLE')}
                </h1>
                <div className="company-information">
                    {vAccounts.map((va, idx) => (
                        <CompanyInformation
                            key={idx}
                            account={va}
                            onClick={() => handleSetVirtualAccount(va.entityId)}
                            currentEntityId={currentEntityId}
                        />
                    ))}
                </div>
                {hasOtherPortalAccounts > 0 && (
                    <div>
                        <h3 className="text-center mb-4 mt-5">
                            {languageManager.T('SWCH_ACC_MDL_OTHER_CONTRACT')}
                        </h3>
                        <Accordion>
                            {otherVAccounts[DOMAIN_FIDUCIAL]?.length > 0 && DOMAIN_NAME !== DOMAIN_FIDUCIAL && (
                                <OtherPortalAccounts 
                                    accounts={otherVAccounts[DOMAIN_FIDUCIAL]}
                                    portalLogo={FIDUCIAL_LOGO}
                                    portalUrl={FIDUCIAL_PORTAL_URL}
                                    portalBrand={FIDUCIAL_BRAND}
                                    eventKey={0}
                                    sessionSerialized={sessionSerialized}
                                />
                            )}
                            {otherVAccounts[DOMAIN_FEDERATED]?.length > 0 && DOMAIN_NAME !== DOMAIN_FEDERATED && (
                                <OtherPortalAccounts 
                                    accounts={otherVAccounts[DOMAIN_FEDERATED]}
                                    portalLogo={FEDERATED_LOGO}
                                    portalUrl={FEDERATED_PORTAL_URL}
                                    portalBrand={FEDERATED_BRAND}
                                    eventKey={1}
                                    sessionSerialized={sessionSerialized}
                                />
                            )}
                            {otherVAccounts[DOMAIN_JADE]?.length > 0 && DOMAIN_NAME !== DOMAIN_JADE && (
                                <OtherPortalAccounts 
                                    accounts={otherVAccounts[DOMAIN_JADE]}
                                    portalLogo={JADE_LOGO}
                                    portalUrl={JADE_PORTAL_URL}
                                    portalBrand={JADE_BRAND}
                                    eventKey={2}
                                    sessionSerialized={sessionSerialized}
                                />
                            )}
                        </Accordion>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={()=> setIsVisible(false)}>{languageManager.T('GEN_BACK')}</Button>
            </Modal.Footer>
        </Modal>
        </>
    )
};

const mapStateToProps = (appState) => ({
    profile: appState.userProfile,
    session: appState.session,
    showVAccountModal: appState.showVAccountModal,
    currentVirtualAccount: appState.session?.currentVirtualAccount
});

const mapDispatchToProps = (dispatch) => ({
    setShowVirtualAccount: (status) => dispatch(actionCreator.Session.setShowVirtualAccount(status)),
    setVirtualAccount: (currentVirtualAccount) => dispatch(actionCreator.Session.setVirtualAccount(currentVirtualAccount)),
    setProfile: (userProfile) => dispatch(actionCreator.Profile.setProfile(userProfile)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualAccountModal);
